export default __webpack_public_path__ + "static/media/AutoGravity-3.0663d14f.jpg";